import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Checkbox,
  Button,
  Link,
  IconButton,
  FormControlLabel,
  InputAdornment,
  useMediaQuery,
} from "@mui/material";

import { Visibility, VisibilityOff, Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../../Assets/Images/f00c31d28a1eab4518d447421a5689b4f924c23b.png";
import bg from "../../Assets/Images/1b74d639e14cfd3a5d4ab476c173d946f0f7bbab.png";

const LoginPage2 = ({ setRole, loginUser }) => {
  const navigate = useNavigate();

  const [otp, setOtp] = useState(new Array(6).fill(""));

  const inputsRef = useRef([]);

  const [view, setView] = useState("login"); // login | forgot | otp | changepass
  const [username, setUsername] = useState("");

  const [password, setPassword] = useState("");
  const [ConfirmPass, setConfirmPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  let userType =
    loginUser === "candidate"
      ? "Candidate"
      : loginUser === "client"
      ? "Client"
      : "";

  let payload1 = {};
  let payload2 = {};
  let payload3 = {};

  if (userType === "Candidate") {
    payload1 = { CI_UserName: username };
    payload2 = { CI_UserName: username, otp: otp.join("") };
    payload3 = { CI_UserName: username, newPassword: password };
  } else if (userType === "Client") {
    payload1 = { CD_UserName: username };
    payload2 = { CD_UserName: username, otp: otp.join("") };
    payload3 = { CD_UserName: username, newPassword: password };
  }

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (element, index) => {
    const value = element.value.replace(/\D/g, ""); // Only digits
    if (value) {
      const updatedOtp = [...otp];
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      // Move focus
      if (index < 5) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const updatedOtp = [...otp];
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handleRememberChange = (event) => {
    setRememberPassword(event.target.checked);
  };

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = () => {
    if (!username || !password) {
      toast.error("Please enter both Username and Password!");
      return;
    }

    const config = {
      admin: {
        url: "/Employee/login",
        payload: {
          ED_UserName: username,
          ED_Password: password,
        },
      },
      candidate: {
        url: "/Candidate/login",
        payload: {
          CI_UserName: username,
          CI_Password: password,
        },
      },
      client: {
        url: "/Client/login",
        payload: {
          CD_UserName: username,
          CD_Password: password,
        },
      },
    };

    const current = config[loginUser?.toLowerCase()];

    if (!current) {
      errorNotify("Invalid user role selected");
      return;
    }

    setIsLoading(true);

    axiosAPI
      .post(current.url, current.payload)
      .then((res) => {        
        if (res?.data?.data?.token) {
          localStorage?.setItem("SWA_RememberPassword", rememberPassword);
          localStorage?.setItem("SWA_RememberPassword_loginUser", loginUser);

          if (rememberPassword) {
            localStorage.setItem("SWA_userRole", loginUser);
            localStorage.setItem("SWA_token", res?.data?.data?.token);
            localStorage.setItem("SWA_UserId", res?.data?.data?.User_Id);
            localStorage.setItem("SWA_IsAdmin", res?.data?.data?.ED_Admin);

            // ✅ Store credentials if Remember Me is checked
            localStorage.setItem("SWA_RememberedUsername", username);
            localStorage.setItem("SWA_RememberedPassword", password); // Optional: avoid this if insecure
          } else {
            sessionStorage.setItem("SWA_userRole", loginUser);
            sessionStorage.setItem("SWA_token", res?.data?.data?.token);
            sessionStorage.setItem("SWA_UserId", res?.data?.data?.User_Id);
            sessionStorage.setItem("SWA_IsAdmin", res?.data?.data?.ED_Admin);

            // ❌ Clear stored credentials if Remember Me is not checked
            localStorage.removeItem("SWA_RememberedUsername");
            localStorage.removeItem("SWA_RememberedPassword");
          }

          successNotify("Logged in Successfully");
          setRole(loginUser);
          navigate("/");
        } else {
          errorNotify(res?.data?.data?.message);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        errorNotify("Something went Wrong!");
      });
  };

  const handleForgotPassword = async () => {
    if (!username) return alert("Username required");
    setIsLoading(true);
    await axiosAPI
      ?.post(`/${userType}/forgot-password`, payload1)
      .then((res) => {
        if (res?.data?.success) {
          if (res?.data?.data?.success) {
            successNotify(res?.data?.data?.message);
            setView("otp");
          } else {
            errorNotify(res?.data?.data?.message);
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        errorNotify("Something went Wrong!");
      });
  };

  const handleVerifyOtp = async () => {
    const finalOtp = otp.join("");

    if (finalOtp?.toString()?.length !== 6) {
      infoNotify("Enter valid 6-digit OTP");
    } else {
      await axiosAPI
        ?.post(`/${userType}/otpValidation`, payload2)
        .then((res) => {
          if (res?.data?.success) {
            if (res?.data?.data?.success) {
              successNotify(res?.data?.data?.message);
              setView("confirmpass");
            } else {
              errorNotify(res?.data?.data?.message);
            }
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          errorNotify("Something went Wrong!");
        });
    }
  };

  const handlePasswordChange = async () => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

    if (password == ConfirmPass) {
      if (password?.length < 8) {
        infoNotify("Password must have at least 8 characters.");
      } else if (!passwordRegex.test(password)) {
        infoNotify(
          "Password must have atleast one uppercase, lowercase, number, and special character."
        );
      } else {
        await axiosAPI
          ?.post(`/${userType}/reset-password`, payload3)
          .then((res) => {
            if (res?.data?.success) {
              if (res?.data?.data?.success) {
                successNotify(res?.data?.data?.message);
                setUsername("");
                setPassword("");
                setView("login");
              } else {
                errorNotify(res?.data?.data?.message);
              }
            }
            setIsLoading(false);
          })
          .catch((err) => {
            setIsLoading(false);
            errorNotify("Something went Wrong!");
          });
      }
    } else {
      infoNotify("Password Mismatch!");
    }
  };

  const handleClose = () => {
    setView("login");
    setUsername("");
    setOtp(new Array(6).fill(""));
  };

  useEffect(() => {
    const isLoggedIn =
      localStorage.getItem("SWA_userRole") || sessionStorage.getItem("SWA_userRole");

    if (["admin", "candidate", "client"].includes(isLoggedIn)) {
      navigate("/");
    }

    if (localStorage?.getItem("SWA_RememberPassword_loginUser") == loginUser) {
      if (localStorage?.getItem("SWA_RememberPassword") == "true") {
        setRememberPassword(
          localStorage?.getItem("SWA_RememberPassword") == "true" ? true : false
        );
        setUsername(localStorage.getItem("SWA_RememberedUsername") || "");
        setPassword(localStorage.getItem("SWA_RememberedPassword") || "");
      } else {
        setRememberPassword(false);
        setUsername("");
        setPassword("");
      }
    } else {
      setRememberPassword(false);
      setUsername("");
      setPassword("");
    }
  }, [navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        p: 2,
      }}
    >
      {/* Semi-transparent overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `linear-gradient(to right,rgba(16, 122, 204, 0.86) 0%,rgba(254, 221, 198, 0.75) 100%) `,
          zIndex: 0,
          backdropFilter: "blur(7px)",
        }}
      />

      {/* Content goes here */}
      <Grid
        container
        sx={{
          position: "relative", // ensures it's above the overlay
          zIndex: 1,
          maxWidth: { sm: `100vw`, md: `80vw` },
          borderRadius: 4,
          overflow: "hidden",
          minHeight: "70vh",
        }}
      >
        {/* Left - Logo and Text */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={8}
          order={{ xs: 1, sm: 1, md: 1 }}
          sx={{
            p: { xs: 3, sm: 4 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Box sx={{ mb: 2, boxShadow: "none" }}>
            <img
              src={logo} // Replace with actual logo path
              alt="Signature Logo"
              style={{ width: 300 }}
            />
          </Box>

          <Typography
            sx={{
              fontFamily: "Geist, sans-serif",
              fontSize: 24,
              fontWeight: "400",
              display: { xs: `none`, sm: "none", md: "block", lg: "block" },
            }}
          >
            Signature leads global recruitment with precision and efficiency,
            <br />
            connecting businesses worldwide with top talent tailored to their
            unique needs.
          </Typography>
        </Grid>

        {/* Right  - Login Glass Card */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          xl={4}
          order={{ xs: 2, sm: 2, md: 2 }}
          sx={{
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.41)",
            p: { xs: 0, sm: 4 },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            borderRadius: "20px",
          }}
        >
          {view == `login` && (
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
                paddingTop: "50px",
              }}
            >
              <Box sx={{ width: "90%", padding: "0px 20px" }}>
                <Typography
                  sx={{
                    mb: 4,
                    fontWeight: `600`,
                    fontSize: `36px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    fontFamily: "Geist, sans-serif",
                    color: "#333333",
                    textAlign: { xs: "center", sm: "center" },
                  }}
                >
                  Login
                </Typography>
              </Box>
              <Box sx={{ width: "90%", padding: "20px" }}>
                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                  >
                    Username
                  </Typography>
                  <TextField
                    value={username}
                    placeholder="Enter your Username"
                    onChange={(e) => setUsername(e.target.value)}
                    inputProps={{ maxLength: 255 }}
                    fullWidth
                    sx={{
                      mb: 2,
                      border: "1px solid transparent",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        background: "white",
                        height: "50px",
                        borderRadius: "10px",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                  >
                    Password
                  </Typography>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    inputProps={{ maxLength: 255 }}
                    fullWidth
                    sx={{
                      // mb: 2,
                      border: "1px solid transparent",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        background: "white",
                        height: "50px",
                        borderRadius: "10px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Box
                display="flex"
                  flexWrap="wrap"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ my: 2, gap: 1 }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ position: "relative", left: "2px" }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={rememberPassword}
                          onChange={handleRememberChange}
                          sx={{
                            color: "black",
                            "&.Mui-checked": {
                              color: "black",
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            color: "black",
                            fontSize: 15,
                            fontFamily: "Geist, sans-serif",
                            fontWeight: "500",
                            cursor: "pointer",
                          }}
                        >
                          Remember Password
                        </Typography>
                      }
                      sx={{ color: "#fff" }}
                    />
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        color: "black",
                        fontSize: 15,
                        fontFamily: "Geist, sans-serif",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setView("forgot");
                        setUsername("");
                      }}
                    >
                      Forgot Password?
                    </Typography>
                  </Box>
                </Box>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 2,
                    backgroundColor: "#145DA0",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                    letterSpacing: "1px",
                    padding: "15px",
                    borderRadius: "10px",
                    boxShadow: "none",
                  }}
                  onClick={handleLogin}
                  disabled={isLoading}
                >
                  {isLoading ? "Logging In..." : "Login"}
                </Button>
              </Box>
            </Box>
          )}

          {view == `forgot` && (
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "black",
                }}
              >
                <Close />
              </IconButton>

              <Box sx={{ width: "90%", padding: "0px 20px" }}>
                <Typography
                  sx={{
                    mb: 4,
                    fontWeight: `600`,
                    fontSize: `36px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    fontFamily: "Geist, sans-serif",
                    color: "#333333",
                    textAlign: { xs: "center", sm: "center" },
                  }}
                >
                  Forgot Password
                </Typography>
              </Box>

              <Box sx={{ width: "90%", padding: "20px" }}>
                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                  >
                    Username
                  </Typography>
                  <TextField
                    placeholder="Enter your Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    inputProps={{ maxLength: 255 }}
                    fullWidth
                    sx={{
                      mb: 2,
                      border: "1px solid transparent",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        background: "white",
                        height: "50px",
                        borderRadius: "10px",
                      },
                    }}
                  />
                </Grid>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 2,
                    backgroundColor: "#145DA0",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                    letterSpacing: "1px",
                    padding: "15px",
                    borderRadius: "10px",
                    boxShadow: "none",
                  }}
                  onClick={handleForgotPassword}
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? "Sending OTP..." : "Send OTP"}
                </Button>
              </Box>
            </Box>
          )}

          {view == "otp" && (
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "black",
                }}
              >
                <Close />
              </IconButton>

              <Box textAlign="center">
                <Typography
                  sx={{
                    mb: 4,
                    fontWeight: `600`,
                    fontSize: `36px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    fontFamily: "Geist, sans-serif",
                    color: "#333333",
                    textAlign: { xs: "center", sm: "center" },
                  }}
                >
                  OTP
                </Typography>
              </Box>

              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 1.5,
                  }}
                >
                  {otp?.map((digit, index) => (
                    <TextField
                      key={index}
                      inputRef={(el) => (inputsRef.current[index] = el)}
                      value={digit}
                      onChange={(e) => handleChange(e.target, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      variant="outlined"
                      inputProps={{
                        maxLength: 1,
                        style: {
                          textAlign: "center",
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: "black",
                          width: "20px",
                          height: "20px",
                          fontFamily: "Geist, sans-serif",
                        },
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "rgba(0, 0, 0, 0.5)",
                          },
                          "&:hover fieldset": {
                            borderColor: "black",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black",
                          },
                          backgroundColor: "rgba(255,255,255,0.1)",
                        },
                      }}
                    />
                  ))}
                </Box>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 5,
                    backgroundColor: "#145DA0",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                    letterSpacing: "1px",
                    padding: "15px",
                    borderRadius: "10px",
                    boxShadow: "none",
                  }}
                  onClick={handleVerifyOtp}
                  disabled={isLoading}
                >
                  {isLoading ? "Verifying OTP..." : "Verify OTP"}
                </Button>
              </Box>
            </Box>
          )}

          {view == "confirmpass" && (
            <Box
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <IconButton
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "black",
                }}
              >
                <Close />
              </IconButton>

              <Box textAlign="center">
                <Typography
                  variant="h4"
                  sx={{
                    mb: 3,
                    fontFamily: "Geist, sans-serif",
                    fontWeight: `400`,
                    fontSize: `40px`,
                    lineHeight: `100%`,
                    letterSpacing: `0%`,
                    color: "black",
                    textTransform: "capitalize",
                  }}
                >
                  Reset Password
                </Typography>
              </Box>

              <Box sx={{ width: "90%", padding: "20px" }}>
                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                  >
                    Password
                  </Typography>
                  <TextField
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    inputProps={{ maxLength: 255 }}
                    fullWidth
                    sx={{
                      mb: 2,
                      border: "1px solid transparent",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        background: "white",
                        height: "50px",
                        borderRadius: "10px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
                  >
                    Confirm Password
                  </Typography>

                  <TextField
                    type={showPassword ? "text" : "password"}
                    placeholder="Confirm Password"
                    value={ConfirmPass}
                    onChange={(e) => setConfirmPass(e.target.value)}
                    inputProps={{ maxLength: 255 }}
                    fullWidth
                    sx={{
                      mb: 2,
                      border: "1px solid transparent",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        background: "white",
                        height: "50px",
                        borderRadius: "10px",
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={toggleShowPassword} edge="end">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 5,
                    backgroundColor: "#145DA0",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                    letterSpacing: "1px",
                    padding: "15px",
                    borderRadius: "10px",
                    boxShadow: "none",
                  }}
                  onClick={handlePasswordChange}
                  disabled={isLoading} // Disable button while loading
                >
                  {isLoading ? "Changing Password..." : "Change Password"}
                </Button>
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default LoginPage2;
